<template>
  <div class="cc-acc-content" v-loading="loading">
    <div class="cc-acc-content-drawer">
      <div class="acc-content-drawer-left">
        <el-form label-width="68px" label-position="left">
          <div class="cc-advertiser-form-box">
            <div class="form-box-top">
              <el-form-item label="登录账号">
                <el-input v-model="filterForm.agentAccount" size="small" @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
              <el-form-item label="账号名称">
                <el-input v-model="filterForm.agentAccountName" size="small" @keyup.enter.native="handleRefresh" clearable ></el-input>
              </el-form-item>
              <el-form-item label="状态" size="small">
                <el-select v-model="filterForm.disabled">
                  <el-option label="不限" value>不限</el-option>
                  <el-option label="启用" :value="0"></el-option>
                  <el-option label="禁用" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-box-center" v-show="isMore">
              <el-form-item  label="手机号" >
                <el-input v-model="filterForm.phone" size="small" @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
              <el-form-item label="邮件地址">
                <el-input v-model="filterForm.email" size="small" @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
              <el-form-item label="账号角色" label-width="80px" size="small">
                <el-select v-model="filterForm.flag">
                  <el-option label="不限" value>不限</el-option>
                  <!-- <el-option label="管理员" :value="0"></el-option> -->
                  <el-option label="操作员" :value="1"></el-option>
                    <el-option label="数据员" :value="3"></el-option>
                   <el-option label="财务" :value="4"></el-option>
                   <el-option label="业务员" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="acc-content-drawer-right">
        <el-button size="small" type="primary" icon="el-icon-search" @click.stop="handleRefresh">查询</el-button>
        <el-button size="small" @click.stop="resetFilter">重置</el-button>
        <el-button size="small" type="text" class="is-more" @click="clickLoadingMore">
          {{isMore ? '收起' : '展开'}}
          <i :class="isMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
      </div>
    </div>
    <div class="cc-acc-content-list">
      <div class="cc-acc-head-but">
        <el-button size="small" type="primary" class="btn-fl" @click="handleCreate">+ 新建账号</el-button>
      </div>
      <Table
        :props="table.props"
        :header="table.header"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
// eslint-disable-next-line no-unused-vars
export default {
  components: {
    Table
  },
  data() {
    return {
      loading: false,
      filterForm: {
        agentAccount: '',
        agentAccountName: '',
        phone: '',
        email: '',
        flag: '',
        disabled: ''
      },
      table: {
        props: {
          border: true,
          stripe: false,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: 'ID',
            prop: 'agentAccountId',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 40
          },
          {
            label: '登录账号',
            prop: 'agentAccount',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 80,
            render: (h, { row }) => {
              return row.agentAccount ? this.$decrypt(row.agentAccount) : ''
            }
          },
          {
            label: '账号名称',
            prop: 'agentAccountName',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 80
          },
          {
            label: '手机号',
            prop: 'phone',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 80
          },
          {
            label: '邮件地址',
            prop: 'email',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 120
          },
          {
            label: '角色',
            prop: 'flag',
            'show-overflow-tooltip': true,
            'min-width': 60,
            align: 'left',
            render: (createElement, { row }) => {
              const arr = ['管理员', '操作员', '业务员', '数据员', '财务']
              return arr[row.flag]
            }
          },
          {
            label: '状态',
            prop: 'disabled',
            'min-width': 60,
            align: 'left',
            'show-overflow-tooltip': true,
            render: (createElement, { row }) => {
              const arr = ['启用', '禁用']
              return arr[row.disabled]
            }
          },
          {
            label: '操作',
            'min-width': 80,
            align: 'left',
            // fixed: 'right',
            isShow: true,
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleRead(row)
                      }
                    }
                  },
                  '详情'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    }
                  },
                  '编辑'
                )
              ])
            }
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      selected: [],
      selectedRow: [],
      isMore: false
    }
  },
  methods: {
    fetchData() {
      let filterForm = this.filterForm
      filterForm.pageNo = this.currentPage
      filterForm.pageSize = this.pageSize
      this.table.data = []
      this.drawerDialog = false
      this.loading = true
      this.$service.getAccAdAgentAccountPageList(filterForm).then(data => {
        this.totalCount = data.total
        this.table.data = data.rows
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleCreate() {
      this.$emit('create')
    },
    resetFilter() {
      this.filterForm = {
        agentAccount: '',
        agentAccountName: '',
        partnerId: '',
        phone: '',
        email: '',
        flag: '',
        disabled: ''
      }
      this.handleRefresh()
    },
    clickLoadingMore() {
      this.isMore = !this.isMore
    },
    handleFilter() {
      this.drawerDialog = true
    },
    handleRead(row) {
      this.$emit('read', row)
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.fetchData()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.agentAccountId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter(item => {
        return item !== targetItem.agentAccountId
      })
      this.selectedRow = this.selectedRow.filter(item => {
        return item.agentAccountId !== targetItem.agentAccountId
      })
      this.updateTableSelected()
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      this.selectedRow = []
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.agentAccountId) > -1) {
          this.selectedRow.push(item)
          result.push(index)
        }
        return result
      }, [])
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    handleAllRowSelectionRemove() {
      this.selected = []
      this.selectedRow = []
      this.table.selected = []
    },

    handleClose() {
      this.drawerDialog = false
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
<style lang="stylus">
.el-drawer__wrapper .el-drawer__header span:focus {
  outline: 0px;
}

.el-drawer__wrapper .el-drawer.ttb {
  height: auto !important;
}
</style>
<style lang="stylus" scoped>
.cc-acc-content {
  padding: 15px;
}

.cc-acc-content .cc-acc-head-but {
  // overflow: hidden;
  margin-bottom 16px

}
.cc-acc-content-drawer {
  background: #FFF;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 16px 16px 16px 24px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
}
// .cc-acc-content-drawer .is-more {
//   padding-left: 10px;
//   color: #FF8B00;
//   font-size: 14px;
//   cursor: pointer;
// }

.cc-acc-content-list {
  background: #FFF;
  padding 16px 24px
}

.acc-content-drawer-left {
 width: calc(100% - 199px);
}

.acc-content-drawer-right {
  width: 191;
  margin-right: 8px;
}

>>>.el-tabs__header {
  margin: 0;
}

.cc-advertiser-form-box {
  display: flex;
  flex-direction column;
  flex-wrap: wrap;
}

.form-box-top,.form-box-center {
  display: flex;
  width 100%
}
.form-box-top>div,.form-box-center>div {
  margin-right 16px
  margin-bottom 0
  width 30%
}
.form-box-center {
  margin-top 16px
}
>>>.el-select {
    display flex
  }
>>>.el-table-button-text {
  color: #1890FF;
}
</style>
